export default "//file.bilionpass.com/japandx-web/0.0.1/static/tanhao_icon.500302c5-0b2108.svg";